
import { Component, Vue, Prop } from 'vue-property-decorator';
import { technologistOrderFormConfiguration } from '@/helpers/OrderHelper';
import { getDatepickerLocale } from '@/helpers/LocaleHelper';
import { TechnologistFormField } from '@/interfaces/components/projectNew/TechnologistFormField';

@Component({
    name: 'TechnologistOrderFormGeneralInfo',
    components: {},
})
export default class TechnologistOrderFormGeneralInfo extends Vue {
    @Prop({ required: true }) private project!: any;
    @Prop({ required: true }) private value!: any;
    @Prop({ required: true }) private errors!: any;

    private get orderFormConfiguration() {
        return technologistOrderFormConfiguration;
    }

    private get regularFormFields(): TechnologistFormField[] {
        return this.orderFormConfiguration.formFields.filter((field) => field.type !== 'date');
    }

    private get dateFormFields(): TechnologistFormField[] {
        return this.orderFormConfiguration.formFields.filter((field) => field.type === 'date');
    }

    private get locale() {
        return getDatepickerLocale();
    }

    private handleFileChange(field: TechnologistFormField, { fileList }: any) {
        this.value[field.name] = fileList;
        this.onFormChange(field); // Clear the error if a file is selected
    }

    private customRequest({ file, onSuccess, onError }: any) {
        // Simulate successful file upload
        setTimeout(() => {
            onSuccess(file);
        }, 1000);
    }

    private onFormChange(field: TechnologistFormField) {
        this.$emit('input', { ...this.value });

        if (field.name === 'numOfOrders') {
            this.$emit('onNumberOfOrdersChange');
        }

        if (!this.errors[field.name]) {
            return;
        }

        this.$emit('validateField', field.name);
    }

    private mounted() {
        if (!this.project) {
            return;
        }

        // Set predefined values from project
        this.value.client = this.project?.client.name ?? '';
        this.value.commercialist = this.project?.assignedUser?.name ?? '';
        this.value.projectConnection = this.project?.connection ?? '';
    }
}
